import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { LabelKey } from '@/core/dcr/fields/labelKey';
import { getFieldLabel } from '@/core/dcr/fields/registry';
import type { CommonFieldDef } from '@/core/dcr/fields/types';

import { useDcrFormContext } from '../_context/DcrFormContext';

export const useTranslateLabel = () => {
	const { t } = useTranslation();

	return useCallback(
		(label: LabelKey) => t(label.key, label.params ?? {}),
		[t]
	);
};

export const useFieldLabel = () => {
	const { countryId } = useDcrFormContext();
	const translate = useTranslateLabel();

	return useCallback(
		(def: Pick<CommonFieldDef, 'label' | 'labelByCountry'>) =>
			translate(getFieldLabel(def, countryId)),
		[countryId, translate]
	);
};
